import { createQuery } from 'react-query-kit';

import * as ProjectTypes from '../api/project/types.api';
import * as ProjectAPI from '../api/project/index.api';

//
//

const key = 'projects';

//

export const useQueryProjectByCodeGet = createQuery<
  ProjectTypes.ProjectResponse,
  ProjectTypes.ProjectQuery
>({
  queryKey: [key],
  fetcher: (params, options) => ProjectAPI.getProjectByCodeAPI(params),
});

export const useQueryProjectsList = createQuery<
  ProjectTypes.ProjectListResponse,
  ProjectTypes.GetProjectsListQuery
>({
  queryKey: [key],
  fetcher: (params, options) => ProjectAPI.getProjectsApi(params),
});

